import React from 'react'
import { IoApps } from 'react-icons/io5'
import TechnologyServicePage from '../components/TechnologyServicePage'

const capabilities = [
    { title: 'Digital Strategy', description: 'Define a practical transformation direction aligned to business goals.' },
    { title: 'Roadmap Development', description: 'Prioritize platforms, processes, and timelines for measurable delivery.' },
    { title: 'Process Automation', description: 'Replace manual workflows with faster, trackable digital operations.' },
    { title: 'Enterprise Modernization', description: 'Upgrade legacy systems, tools, and operating models.' },
    { title: 'Digital Governance', description: 'Create standards that keep technology secure, consistent, and scalable.' },
    { title: 'Change Management', description: 'Support teams as new systems and digital ways of working are adopted.' }
]

const DigitalTransformation = () => (
    <TechnologyServicePage
        badge="Digital Transformation"
        title="Move from manual operations to modern, connected digital systems."
        description="We help organizations assess readiness, redesign processes, and build clear digital roadmaps for sustainable transformation."
        metaDescription="Digital transformation strategy, roadmaps, process automation, enterprise modernization, and digital governance from VRIFY Technologies."
        icon={<IoApps className="text-sm" />}
        capabilities={capabilities}
        outcomes={[
            { title: 'Clear direction', description: 'A focused digital roadmap built around your real priorities.' },
            { title: 'Smarter workflows', description: 'Reengineered processes that reduce delays and improve visibility.' },
            { title: 'Future-ready teams', description: 'Guidance that helps people adopt new tools with confidence.' }
        ]}
        highlights={[
            { title: 'Assess', description: 'Review digital readiness, current systems, and operational gaps.' },
            { title: 'Modernize', description: 'Improve business processes, platforms, and governance structures.' },
            { title: 'Scale', description: 'Build foundations that support automation, analytics, and innovation.' }
        ]}
        cta={{
            eyebrow: 'Transformation starts here',
            title: 'Build a simpler, smarter digital operating model.',
            description: 'Let us help you turn complex processes into connected, measurable digital experiences.'
        }}
    />
)

export default DigitalTransformation
